// src/pages/BackupPage.jsx
import React, { useState } from "react";
import api from "../../../services/api";
import { FaDatabase, FaFileDownload } from "react-icons/fa";
import styles from "./BackupPage.module.css";

export default function BackupPage() {
  const currentYear = new Date().getFullYear();
  const years = Array.from({ length: 5 }, (_, i) => currentYear - i); // последние 5 лет
  const months = [
    { value: "01", name: "Январь" },
    { value: "02", name: "Февраль" },
    { value: "03", name: "Март" },
    { value: "04", name: "Апрель" },
    { value: "05", name: "Май" },
    { value: "06", name: "Июнь" },
    { value: "07", name: "Июль" },
    { value: "08", name: "Август" },
    { value: "09", name: "Сентябрь" },
    { value: "10", name: "Октябрь" },
    { value: "11", name: "Ноябрь" },
    { value: "12", name: "Декабрь" },
  ];

  const [year, setYear] = useState(currentYear.toString());
  const [month, setMonth] = useState(
    String(new Date().getMonth() + 1).padStart(2, "0")
  );

  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);

  const handleBackupChecks = async () => {
    setLoading(true);
    setResult(null);
    try {
      const res = await api.get(`/check/export?year=${year}&month=${month}`);
      setResult(res);
    } catch (e) {
      setResult({ error: e.response?.data?.message || e.message });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.page}>
      <header className={styles.header}>
        <h1><FaDatabase /> Резервные копии</h1>
        <p>Создавайте бэкапы перед очисткой данных</p>
      </header>

      <main className={styles.main}>
        <div className={styles.card}>
          <h3>Бэкап фискальных чеков</h3>
          <p>Сохраняет чеки за выбранный месяц в отдельные JSON-файлы.</p>

          <div className={styles.controls}>
            <label>
              Год:
              <select value={year} onChange={(e) => setYear(e.target.value)}>
                {years.map((y) => (
                  <option key={y} value={y}>{y}</option>
                ))}
              </select>
            </label>

            <label>
              Месяц:
              <select value={month} onChange={(e) => setMonth(e.target.value)}>
                {months.map((m) => (
                  <option key={m.value} value={m.value}>{m.name}</option>
                ))}
              </select>
            </label>

            <button
              className={styles.backupBtn}
              onClick={handleBackupChecks}
              disabled={loading}
            >
              {loading ? "Создание..." : <><FaFileDownload /> Создать бэкап</>}
            </button>
          </div>

          {result && (
            <div className={styles.result}>
              {result.error ? (
                <p className={styles.error}>❌ {result.error}</p>
              ) : (
                <div>
                  <p className={styles.success}>✅ {result.message}</p>
                  <p><b>Год:</b> {result.year} &nbsp; <b>Месяц:</b> {result.month}</p>
                  <p><b>Всего чеков:</b> {result.totalChecks}</p>
                  <p><b>Создано файлов:</b> {result.filesCreated}</p>

                  {Array.isArray(result.details) && result.details.length > 0 && (
                    <div className={styles.filesList}>
                      {result.details.map((f, i) => (
                        <div key={i} className={styles.fileItem}>
                          📄 {f.file} — {f.count} шт.
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              )}
            </div>
          )}
        </div>
      </main>
    </div>
  );
}
